<script>
import { mapState } from 'vuex';

// Importing the components from their respective files
// import Navbar from './components/navigation/Sidebar';
import Navbar from './components/navigation/TopNavbar';
import ConstructionApp from './components/construction/ConstructionApp';

export default {
  name: 'App',
  data() {
    return {
      construction: process.env.UnderConstruction,
    };
  },
  computed: {
    ...mapState({
      progressVal: (state) => state.progressVal,
      dataFetched: (state) => state.dataFetched,
      notLoaded: (state) => state.notLoaded,
      loaded(state) {
        if (state) {
          return state.loaded;
        }
        return false;
      },
    }),
  },
  components: {
    // Components on the landing page
    'nav-bar': Navbar,
    'construction-app': ConstructionApp,
  },
};
</script>

<template>
  <div id="app">
    <!-- Loader that displays when switching between different pages -->
    <construction-app v-if="construction"></construction-app>
    <b-container
      style="background-color: #1A1F26; height: 100%;"
      class="p-0 m-0"
      v-if="!loaded && !construction"
      fluid
    >
      <b-row class="text-center m-0" style="height:100%" align-v="center">
        <b-col>
          <div style="text-align: center;">
            <img src="https://i.redd.it/ad27atzy1zxz.gif" style="margin-bottom: -6em" />
            <b-progress
              style="width:400px;margin: 0 auto;z-index:9999"
              :value="progressVal"
              :max="100"
              show-progress
              animated
            ></b-progress>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid style="height: 100%;" v-if="loaded && !construction">
      <b-row class="d-md-none" style="height: 100%;">
        <b-col cols="12" class="text-center mobile-experience">
          <div class="lead text-light pt-5">
            <span class="bg-dark">
              For the best experience,
              please open on a larger screen.
            </span>
          </div>
        </b-col>
      </b-row>
      <b-row style="height: 6%;" id="navbar-container">
        <b-col cols="12" class="p-0">
          <nav-bar></nav-bar>
        </b-col>
      </b-row>
      <router-view></router-view>
    </b-container>
  </div>
</template>

<style>
@media screen and (max-width: 990px){
  .mobile-experience {
    position: relative;
    background: url(https://i.gifer.com/iit.gif);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .navbar {
    display: none;
  }
  #app-container {
      display: none;
  }
  #app-page {
      display: none;
  }
}
</style>
